module.exports = {
  whiteInstitutions: [
    {
      appName: 'UBLD',
      bundleIdSuffix: 'UBLD',
      institutionName: 'UBLD',
      institutionPath: 'ubld',
    },
  ],
};
